import React from 'react';
import '../../../less/index.less';
import '../less/guarantees.less';
import hero_img from '../img/hero_img.svg';
import Hero from '../../../../../../../auxiliary-components/shared/HeroBlock';
import InfoBlock from '../../../../../../../auxiliary-components/shared/InfoBlock';
import BusinessOrder from '../../../../../../BusinessOrder';
import hero_data from '../enums/hero_data.json';
import AdditionalProduct from './../../../../../../../auxiliary-components/shared/AdditionalProductBlock';
import additional_cards from '../enums/additional_cards_data.json';
import { getUrl } from "utils/corploansUrl";

export default function template() {
    const page = 'business-gov-guarantees';
      
    const handlersMap = {
      toggleHeroModal: () => this.toggleModal(),
      corploansDefaultLink: getUrl(),
      corploansLoanlineLink: getUrl('loanline'),
      tariffsLink: '/static/business/business_gov_guarantees_tarrifs.pdf',
      tariffsLineLink: '/static/business/business_gov_guarantees_tarrifs_line.pdf',
    };

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        onClick: handlersMap[hero_data.link.onClick],
      },
    };

    const additionalCards = additional_cards.map(item => ({
      ...item,
      link: handlersMap[item.link],
      link2: handlersMap[item.link2]
    }));

    return (
      <div className="business-gov-guarantees">
        <Hero
          data={heroData}
          img={hero_img}
          svg
          page={page}
          className="gov-programs"
        />
        <div className="content">
          <div className="we-support-row">
            <div className="container">
              <h2 className="we-support-row__title">{this.l10n('BUSINESS_GOV_GUARANTEES_NEW_WE_SUPPORT_TITLE')}</h2>
              <div className="we-support-row__body">
                <div className="we-support-row__left">
                  <p>{this.l10n('BUSINESS_GOV_GUARANTEES_NEW_WE_SUPPORT_TEXT_01')}</p>
                  <p>{this.l10n('BUSINESS_GOV_GUARANTEES_NEW_WE_SUPPORT_TEXT_02')}</p>
                  <p>{this.l10n('BUSINESS_GOV_GUARANTEES_NEW_WE_SUPPORT_TEXT_03')}</p>
                </div>
                <InfoBlock 
                  text={'BUSINESS_GOV_GUARANTEES_NEW_INFO_TEXT'}
                />
              </div>
            </div>
          </div>
          <AdditionalProduct
            items={additionalCards}
            title={'BUSINESS_GOV_GUARANTEES_NEW_ADDITIONAL_PRODUCT_TITLE'}
            page={page}
          />
        </div>
        {this.state.showModal && <BusinessOrder attribute="gov_guarantees" closeModal={this.toggleModal} />}
      </div>
    );
}